import { Box } from "@mui/material"
import { type ColumnSort, type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"
import React from "react"
import type { CombinedError } from "urql"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import { expandedCellStyles } from "@/components/Tables/Aeros/shared"
import type { CompetitorProduct } from "@/graphql/codegen/graphql"
import { useCompetitorProductsColumns } from "@/screens/ManageProducts/components/CompetitorProducts/hooks/useCompetitorProductsColumns"

interface CompetitorProductsTableProps {
  data: CompetitorProduct[]
  fetching?: boolean
  error?: CombinedError | Error
  sorting: ColumnSort[]
  onHandleSortingChange: (updaterFn: (state: SortingState) => SortingState) => void
  onEdit?: (product: CompetitorProduct) => void
  onDelete?: (competitorProductId: string, productName: string) => Promise<boolean>
}

const CompetitorProductsTable: FC<CompetitorProductsTableProps> = ({
  data,
  error,
  fetching = false,
  sorting,
  onHandleSortingChange,
  onEdit,
  onDelete,
}) => {
  const columns = useCompetitorProductsColumns({ onEdit, onDelete })

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable
        error={error as Error | undefined}
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              sorting,
              isLoading: fetching,
            },
            manualSorting: true,
            enableSorting: true,
            enableMultiSort: false,
            enableSortingRemoval: false,
            getCoreRowModel: getCoreRowModel(),
            onSortingChange: onHandleSortingChange as OnChangeFn<SortingState>,
          },
        }}
        slotProps={{
          bodyCellExpanded: { className: "bg-primary-100" },
          expandedCell: expandedCellStyles,
          bodyRow: {
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No competitor products found'
      />
    </Box>
  )
}

export default CompetitorProductsTable
